import { chakra, Tab, TabList, TabProps, Tabs } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  onChange: (index: number) => void;
  index: number;
  tabItemProps?: TabProps;
  items: string[];
  isFullWidth?: boolean;

}

const ButtonTabs: FC<Props> = ({ onChange, index, items, tabItemProps, isFullWidth = false, ...props }) => {
  return (
    <Tabs onChange={onChange} index={index} {...props}>
      <TabList
        borderBottom="none"
        overflowY="hidden"
        sx={{
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        h="40px"
      >
        {items.map((label, itemIndex) => {
          const isFirst = itemIndex === 0;
          const isLast = itemIndex === items.length - 1;

          return (
            <Tab
              key={itemIndex}
              flex={isFullWidth ? 1 : undefined}
              flexShrink={0}
              borderLeftRadius={isFirst ? '6px' : '0'}
              borderRightRadius={isLast ? '6px' : '0'}
              mr={isLast ? '0' : '3px'}
              h="100%"
              borderBottom="none"
              bgColor={itemIndex === index ? Color.Primary500 : Color.Shade500}
              fontWeight={700}
              color={Color.OnPrimary}
              _selected={{
                color: Color.OnPrimary,
              }}
              {...tabItemProps}
            >
              {label}
            </Tab>
          );
        })}
      </TabList>
    </Tabs>
  );
};

export default chakra(ButtonTabs);
